module.exports = "<p>\r\n  root works!\r\n</p>\r\n"